import { clsx } from "clsx";
import React, { useContext } from "react";
import { useAccordionButton } from "react-bootstrap/AccordionButton";
import AccordionContext from "react-bootstrap/AccordionContext";
import { Link } from "react-router-dom";
import { RenderWhen } from "../../../components";
import Icon from "../../../components/Icon";

const RlNavItemInnerContent: React.FC<{
  topLevel?: boolean;
  topLevelStatic?: boolean;
  accordionKey?: string;
  className: string;
  icon?: string;
  iconAdditionalClassName?: string;
  text: string;
  textClassName?: string;
  label?: React.ReactNode;
  onClick?: any;
  hasChildren?: boolean;
  image?: {
    src: string;
    alt: string;
  };
  link?: string;
  linkState?: any;
  helpText?: string;
  "data-testid": string;
  onSelectOpenFirstChild?: boolean;
}> = ({
  topLevel = false,
  topLevelStatic = false,
  accordionKey = "",
  className,
  icon,
  iconAdditionalClassName,
  text,
  textClassName,
  label,
  onClick,
  hasChildren,
  image,
  link,
  linkState,
  helpText,
  "data-testid": dataTestId,
  onSelectOpenFirstChild = false
}) => {
  const iconClassName =
    topLevel || topLevelStatic ? "top-level-icon" : "basic-item-icon";
  const onClickToggleAccordion = useAccordionButton(accordionKey, onClick);
  const { activeEventKey } = useContext(AccordionContext);
  const isOpen = activeEventKey === accordionKey;

  const isBasicDropdownItem = hasChildren && !topLevel && !topLevelStatic;

  const MainTextElement = link ? Link : "div";

  const topElementClickAction = () => {
    if ((topLevelStatic || link) && !onSelectOpenFirstChild) return;
    if (hasChildren) {
      onClickToggleAccordion(onClick);
    } else {
      onClick?.();
    }
  };

  return (
    <div
      onClick={topElementClickAction}
      className={`${className} ${
        (hasChildren && (isOpen ? "opened" : "closed")) || ""
      }`}
      data-testid={`rl_nav_item_container_${dataTestId}`}
    >
      {isBasicDropdownItem && (
        <Icon
          name="chevron-down"
          onClick={onClickToggleAccordion}
          className="rl-nav__dropdown-icon"
          data-testid={`rl_nav_item_dropdown_trigger_${dataTestId}`}
        />
      )}
      {icon && (
        <Icon
          name={icon}
          className={clsx(`rl-nav__${iconClassName}`, iconAdditionalClassName)}
        />
      )}
      {image && (
        <img
          src={image.src}
          alt={image.alt}
          width="28"
          height="36"
          className="rl-nav__top-level-image"
        />
      )}
      <div
        className="rl-nav__text-container"
        onClick={isBasicDropdownItem ? onClick : null}
      >
        <MainTextElement
          to={link ?? "#"}
          state={linkState}
          className="rl-nav__text-container-inner"
          data-testid={`rl_nav_item_link_${dataTestId}`}
        >
          <span
            className={textClassName}
            data-testid={`rl_nav_item_text_${dataTestId}`}
          >
            {text}
          </span>
          {helpText && (
            <span
              className="rl-nav__help-text"
              data-testid={`rl_nav_item_help_text_${dataTestId}`}
            >
              {helpText}
            </span>
          )}
        </MainTextElement>
        {label}
      </div>
      <RenderWhen condition={topLevel}>
        <Icon
          name={`chevron-${isOpen ? "up" : "down"}`}
          className="rl-nav__right-dropdown-icon"
        />
      </RenderWhen>
    </div>
  );
};

export default RlNavItemInnerContent;
